<div class="fx-column">
  <app-single-crawler-page-header
    class="mv-8"
    [title]="integration?.name || ''"
    [subtitle]="subtitle">
    <div headerActions class="fx-row align-items-center justify-content-end">
      @if (crawler) {
        <mat-icon class="dark clickable" matRipple fontSet="material-icons-outlined" [cdkMenuTriggerFor]="menu"
          roleBasedElement [roles]="['SUPERADMIN','ADMIN','MANAGER']">more_vert</mat-icon>
        <ng-template #menu>
          <mat-card class="menu-container p-0 elevation" cdkMenu>
            <div class="fx-column">
              @switch (crawler.type) {
                @case (CrawlerType.SINGLE_URL) {
                  @if (canCancel()) {
                    <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                         (click)="cancel()">
                      <mat-icon class="red mr-5" fontSet="material-icons-outlined">stop_circle</mat-icon>
                      <span class="text">{{ 'ACTIONS.CANCEL' | translate }}</span>
                    </div>
                  }
                }
                @case (CrawlerType.EXCEL_BATCH) {
                  @if (canCancel()) {
                    <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                         (click)="cancel()">
                      <mat-icon class="red mr-5" fontSet="material-icons-outlined">stop_circle</mat-icon>
                      <span class="text">{{ 'ACTIONS.CANCEL' | translate }}</span>
                    </div>
                  }
                  <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                       (click)="viewCrawlerConfig()">
                    <mat-icon class="dark mr-5">settings</mat-icon>
                    <span class="text">{{ 'INTEGRATIONS.VIEW_CONFIG' | translate }}</span>
                  </div>
                }
                @case (CrawlerType.DISCOVERY) {
                  @if (canCancel()) {
                    <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                         (click)="cancel()">
                      <mat-icon class="red mr-5" fontSet="material-icons-outlined">stop_circle</mat-icon>
                      <span class="text">{{ 'ACTIONS.CANCEL' | translate }}</span>
                    </div>
                  }
                }
              }
              <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                (click)="edit()">
                <mat-icon class="dark mr-5" fontSet="material-icons-outlined">edit</mat-icon>
                <span class="text">{{'ACTIONS.EDIT' | translate}}</span>
              </div>
              <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                (click)="delete()">
                <mat-icon class="red mr-5" fontSet="material-icons-outlined">delete</mat-icon>
                <span class="text">{{'ACTIONS.DELETE' | translate}}</span>
              </div>
            </div>
          </mat-card>
        </ng-template>
      }
    </div>
  </app-single-crawler-page-header>

  @if (!loading && done && integration && crawler) {
    <app-single-crawler-summary-card
      class="mv-8"
      [name]="integration.name"
      [status]="liveStatus"
      [url]="specUrl"
      [frequencyLabel]="summaryFrequencyLabel"
      [countries]="summaryCountries"
      [searchDepth]="searchDepth"
      [maxPages]="maxPages"></app-single-crawler-summary-card>

    <app-single-crawler-stepper
      class="mv-8"
      [steps]="steps"
      [liveStatus]="liveStatus"
      [activeIndex]="activeStepIndex"
      (stepSelected)="selectStep($event)"></app-single-crawler-stepper>

    <section class="fx-column mv-16">
      @switch (activeStepKey) {
        @case (IntegrationRunStepKey.DISCOVERY) {
          <app-single-crawler-discovery-step [crawler]="crawler"
                                             [integrationId]="integration._id"
                                             [eligibilityPoller]="eligibilityPoller"
                                             (discoveryLaunched)="onRunLaunched()"></app-single-crawler-discovery-step>
        }
        @case (IntegrationRunStepKey.CRAWL) {
          <app-single-crawler-crawl-step [crawler]="crawler" [integrationId]="integration._id"
                                         [integrationName]="integration.name"
                                         [eligibilityPoller]="eligibilityPoller"
                                         (crawlLaunched)="onRunLaunched()"></app-single-crawler-crawl-step>
        }
        @case (IntegrationRunStepKey.ANALYZE) {
          <app-single-crawler-analyze-step [integrationId]="integration._id"></app-single-crawler-analyze-step>
        }
      }
    </section>
  }
</div>
